import { useState, useRef } from "react";

import { API_URL, scroll, isFieldError } from "../helpers";

import Input from "../components/Input";
import Select from "../components/Select";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Invitation = ({ details }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		prefix: details.prefix,
		fname: details.fname,
		lname: details.lname,
		email: details.email,
	});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/guestInvitation`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "homeIntl" ||
				key === "sportingFirst" ||
				key === "sportingAccept"
			) {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("id", details.id);
		data.append(
			"events",
			JSON.stringify(details.events.map((item) => item.id)),
		);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				scroll();
				window.location.reload();
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			<p>
				<strong>{details.registrationName}</strong> has invited you to
				participate in the 2027 Benefit for Children under their sponsorship.
				Please accept or decline the event invitation(s) below.
			</p>

			<p>
				Once you have confirmed your acceptance, you will need to proceed
				through a brief registration process and submit required details.
			</p>

			<div className="spacer"></div>

			<form
				ref={formElement}
				method="post"
				action="/"
				onSubmit={(e) => handleSubmit(e)}
				className="well"
			>
				<h4
					style={{
						marginTop: "0",
						lineHeight: "22px",
						marginBottom: "10px",
						fontSize: "1.1rem",
					}}
				>
					Invitation for {details.fname} {details.lname}
				</h4>

				<table className="approved guest">
					<thead>
						<tr>
							<th className="select">Select</th>
							<th className="left">Event Name</th>
						</tr>
					</thead>
					<tbody>
						{details.events.map((item) => {
							return (
								<tr key={item.id}>
									<td className="select">
										<Select
											name={item.id}
											label=""
											reqd={true}
											value={""}
											options={[
												{ id: "", name: "--" },
												{ id: "accept", name: "Accept" },
												{ id: "decline", name: "Decline" },
											]}
											update={handleUpdate}
											error={isFieldError(errors, item.id)}
										/>
									</td>
									<td className="left event">
										<div className="flex">
											{names[item.id] === "accept" ? (
												<i className="fa fa-check-circle success fa-2x" />
											) : names[item.id] === "decline" ? (
												<i className="fa fa-times-circle error fa-2x" />
											) : (
												<i
													className="fa fa-circle fa-2x"
													style={{ color: "#f9f9f9" }}
												/>
											)}
											<div>
												<h4>{item.name}</h4>
												<p>{item.description}</p>
											</div>
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>

				<div
					className={
						names.golf === "accept" ||
						names.sporting === "accept" ||
						names.welcome === "accept" ||
						names.gift === "accept"
							? ""
							: "hidden"
					}
				>
					<div className={names.sporting === "accept" ? "" : "hidden"}>
						<p style={{ color: "red" }}>
							In order to preserve the safety of Valero’s employees, volunteers,
							vendors, partners, sponsors, participants and attendees of the
							sporting clays event,{" "}
							<strong>
								first time shooters are prohibited from participating in the
								Benefit for Children Sporting Clays event.
							</strong>
						</p>

						<div
							className="form-group checkbox"
							style={{ marginTop: "0", marginBottom: "15px" }}
						>
							<Checkbox
								name="sportingFirst"
								label="By checking this box, you indicate you are not a first time shooter."
								checked={false}
								click={handleUpdate}
							/>
						</div>
					</div>

					<h4
						style={{
							marginTop: "25px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Contact Information
					</h4>

					<div className="form-group">
						<Select
							name="prefix"
							label="Prefix"
							reqd={true}
							value={names.prefix || ""}
							options={[
								{ id: "", name: "--" },
								{ id: "Mr.", name: "Mr." },
								{ id: "Mrs.", name: "Mrs." },
								{ id: "Ms.", name: "Ms." },
								{ id: "Dr.", name: "Dr." },
								{ id: "Other", name: "Other" },
							]}
							update={handleUpdate}
							error={isFieldError(errors, "prefix")}
						/>
						<div className="empty" />
					</div>

					<div className="form-group">
						<Input
							name="fname"
							label="First Name"
							reqd={true}
							value={names.fname || ""}
							autocomplete="given-name"
							update={handleUpdate}
							errors={errors}
						/>

						<Input
							name="lname"
							label="Last Name"
							reqd={true}
							value={names.lname || ""}
							autocomplete="family-name"
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className="form-group">
						<Input
							name="title"
							label="Title"
							reqd={true}
							value={names.title || ""}
							autocomplete="organization-title"
							update={handleUpdate}
							errors={errors}
						/>
						<Input
							name="organization"
							label="Organization"
							reqd={true}
							value={names.organization || ""}
							autocomplete="organization"
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className="form-group">
						<Input
							name="email"
							label="Email"
							reqd={true}
							value={names.email || ""}
							update={handleUpdate}
							errors={errors}
						/>
						<Input
							name="phone"
							label="Phone"
							reqd={true}
							value={names.phone || ""}
							autocomplete="tel"
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<h4
						style={{
							marginTop: "15px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Home Shipping Address
					</h4>

					<div className="form-group checkbox" style={{ marginTop: "10px" }}>
						<Checkbox
							name="homeIntl"
							label="Check if your home address is International (not US or CA)"
							checked={false}
							click={handleUpdate}
						/>
					</div>

					<div className="form-group one">
						<Input
							name="homeAddress"
							label="Address"
							reqd={true}
							value={names.homeAddress || ""}
							autocomplete="street-address"
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className="form-group three">
						<Input
							name="homeCity"
							label="City"
							reqd={true}
							value={names.homeCity || ""}
							autocomplete="address-level2"
							update={handleUpdate}
							errors={errors}
						/>

						{!names.homeIntl && (
							<Input
								name="homeSt"
								label="State (2-letter)"
								reqd={true}
								value={names.homeSt || ""}
								autocomplete="address-level1"
								update={handleUpdate}
								errors={errors}
							/>
						)}

						<Input
							name="homeZip"
							label="Zip Code"
							reqd={true}
							value={names.homeZip || ""}
							autocomplete="postal-code"
							update={handleUpdate}
							errors={errors}
						/>

						{names.homeIntl && (
							<Input
								name="homeCountry"
								label="Country Code (2-letter)"
								reqd={true}
								value={names.homeCountry || ""}
								autocomplete="cuntry"
								update={handleUpdate}
								errors={errors}
							/>
						)}
					</div>

					<div className="form-group" style={{ marginTop: "20px" }}>
						<Select
							name="employee"
							label="Are you a Valero SAHQ Employee?  (Please only select “Yes” if your office/cubicle is located in the San Antonio office)"
							reqd={true}
							value={names.employee || ""}
							options={[
								{ id: "", name: "--" },
								{ id: "Yes", name: "Yes" },
								{ id: "No", name: "No" },
							]}
							update={handleUpdate}
							error={isFieldError(errors, "employee")}
						/>

						{names.employee === "Yes" ? (
							<Input
								name="cubicle"
								label="Office/Cubicle Number"
								reqd={true}
								value={names.cubicle || ""}
								autocomplete="off"
								update={handleUpdate}
								errors={errors}
							/>
						) : (
							<div className="empty" />
						)}
					</div>
				</div>

				<div className={names.golf === "accept" ? "" : "hidden"}>
					<h4
						style={{
							marginTop: "25px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Golf Information
					</h4>

					<div className="form-group">
						<Select
							name="rental"
							label="Do you need Rental Clubs?"
							reqd={true}
							value={""}
							options={[
								{ id: "", name: "--" },
								{
									id: "I will bring my own clubs",
									name: "I will bring my own clubs",
								},
								{ id: "Men’s Left", name: "Men’s Left" },
								{ id: "Men’s Right", name: "Men’s Right" },
								{ id: "Women’s Left", name: "Women’s Left" },
								{ id: "Women’s Right", name: "Women’s Right" },
							]}
							update={handleUpdate}
							error={isFieldError(errors, "rental")}
							note="Due to the large number of guests, we ask that you please bring your own clubs if possible!"
						/>

						<div className="empty" />

						{/* removed 11/8/23 per Samantha <Input
							name="shoe"
							label="Shoe Size"
							reqd={true}
							value={names.shoe || ""}
							update={handleUpdate}
							errors={errors}
						/>*/}
					</div>
				</div>

				<div className={names.sporting === "accept" ? "" : "hidden"}>
					<h4
						style={{
							marginTop: "25px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Sporting Clays Information
					</h4>

					<p style={{ color: "red" }}>
						By checking this box, you are certifying that the registered
						participant (i) is familiar with the use and operation of the
						shotgun(s) that he/she will be using during this event and with the
						rules of shooting and firearm safety, (ii) has previously
						participated in trap, skeet, or sporting clays events or
						participated in similar sporting or hunting activities (e.g., wing
						shooting), and (iii) understands that this activity is potentially
						or inherently dangerous, and that he/she assumes full responsibility
						for his/her conduct and for any injuries or property damage he/she
						may cause or sustain while engaging in this activity. Participation
						in the event may be immediately terminated for any violation of
						facility rules or any safety reason.
					</p>

					<div
						className="form-group checkbox"
						style={{ marginTop: "0", marginBottom: "25px" }}
					>
						<Checkbox
							name="sportingAccept"
							label="By checking this box, you indicate acceptance of the above participation disclaimer."
							checked={false}
							click={handleUpdate}
						/>
					</div>
				</div>

				<div className={names.gift === "accept" ? "" : "hidden"}>
					<h4
						style={{
							marginTop: "25px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Gift Package Information
					</h4>

					{names.golf === "accept" ||
					names.sporting === "accept" ||
					names.gift === "accept" ? (
						<div className="form-group">
							<Select
								name="shirt"
								label="Shirt Size"
								reqd={true}
								value={""}
								options={[
									{ id: "", name: "--" },
									{ id: "Men’s S", name: "Men’s S" },
									{ id: "Men’s M", name: "Men’s M" },
									{ id: "Men’s L", name: "Men’s L" },
									{ id: "Men’s XL", name: "Men’s XL" },
									{ id: "Men’s XXL", name: "Men’s XXL" },
									{ id: "Men’s 3XL", name: "Men’s 3XL" },
									{ id: "Women’s S", name: "Women’s S" },
									{ id: "Women’s M", name: "Women’s M" },
									{ id: "Women’s L", name: "Women’s L" },
									{ id: "Women’s XL", name: "Women’s XL" },
								]}
								update={handleUpdate}
								error={isFieldError(errors, "shirt")}
							/>
							<div className="empty" />

							{/*names.sporting === "accept" ? (
								<Select
									name="boot"
									label="Snake Boot Size"
									reqd={true}
									value={""}
									options={[
										{ id: "", name: "--" },
										{ id: "Men’s 7", name: "Men’s 7" },
										{ id: "Men’s 7.5", name: "Men’s 7.5" },
										{ id: "Men’s 8", name: "Men’s 8" },
										{ id: "Men’s 8.5", name: "Men’s 8.5" },
										{ id: "Men’s 9", name: "Men’s 9" },
										{ id: "Men’s 9.5", name: "Men’s 9.5" },
										{ id: "Men’s 10", name: "Men’s 10" },
										{ id: "Men’s 10.5", name: "Men’s 10.5" },
										{ id: "Men’s 11", name: "Men’s 11" },
										{ id: "Men’s 11.5", name: "Men’s 11.5" },
										{ id: "Men’s 12", name: "Men’s 12" },
										{ id: "Men’s 13", name: "Men’s 13" },
										{ id: "Men’s 14", name: "Men’s 14" },
										{ id: "Women’s 5", name: "Women’s 5" },
										{ id: "Women’s 6", name: "Women’s 6" },
										{ id: "Women’s 7", name: "Women’s 7" },
										{ id: "Women’s 8", name: "Women’s 8" },
										{ id: "Women’s 9", name: "Women’s 9" },
										{ id: "Women’s 10", name: "Women’s 10" },
										{ id: "Women’s 11", name: "Women’s 11" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "boot")}
								/>
							) : (
								<div className="empty" />
							)*/}
						</div>
					) : (
						<div className="form-group"></div>
					)}
				</div>

				{names.gift === "accept" && names.sporting === "accept" && (
					<p>
						Sizing is standard to the Brannock Device. Boots run true to size.
					</p>
				)}

				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit submit="Submit Invite Response" />
					</div>
				</div>
			</form>
		</>
	);
};

export default Invitation;
